import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import { FixedSizeList as List } from 'react-window';
import { Button } from '../Button';
import { Popover } from '../Popover';
import { TextInput } from '../TextInput';
import { chevronIcon, crossIcon, searchIcon } from './icons';
import { PopoverInteractionKind } from '@blueprintjs/core';
const escapeRegExp = (str) => {
    return str.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
const testTextHighlighting = (text, substr) => {
    if (!text) {
        return '';
    }
    const parts = text.split(new RegExp(`(${escapeRegExp(substr)})`, 'gi'));
    const substring = substr ? substr.toLowerCase() : substr;
    return (React.createElement("span", null,
        parts.map((part, i) => (React.createElement("span", { key: `text_highlighting_${i}`, className: cx({
                highlighter: part.toLowerCase() === substring,
            }) }, part))),
        ' '));
};
export const PersonFilter = ({ searchData, searchValue, onSearchUpdate, onItemSelect, onClearSelect, selectedData, languageData, isLoading, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const PersonFilterResult = ({ index, style }) => {
        const selectItemOnClick = () => {
            onItemSelect(searchData[index]);
            setIsOpen(false);
        };
        const selectItemOnKeyPress = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onItemSelect(searchData[index]);
                setIsOpen(false);
            }
        };
        const indexData = searchData[index];
        const nameArray = [];
        [indexData.firstName, indexData.lastName].forEach((field) => {
            if (field) {
                nameArray.push(field.trimRight());
            }
        });
        const name = nameArray.join(' ');
        const { streetAddress, streetAddress2, city, state, postcode } = indexData.address;
        const fieldArray = [streetAddress, streetAddress2, city, state, postcode];
        const addressArray = [];
        fieldArray.forEach((field) => {
            if (field) {
                addressArray.push(field.trimRight());
            }
        });
        const address = addressArray.join(', ');
        return (React.createElement("div", { key: `person_filter_${indexData.id}`, style: style, onClick: selectItemOnClick, onKeyPress: selectItemOnKeyPress, tabIndex: 0, className: cx('filter-menu-item', 'filter-person-container', {
                'filter-item-selected': false,
            }) },
            React.createElement("div", { className: "filter-person-container_full-name" }, testTextHighlighting(name, searchValue)),
            React.createElement("div", { className: "filter-person-container_address" }, address),
            indexData.phoneNumbers.length > 0 ? (React.createElement("div", { className: "filter-person-container_phone-number" }, indexData.phoneNumbers[0].number)) : null));
    };
    const onPopoverClick = (nextOpenState, event) => {
        if (typeof event !== 'undefined' && event.type === 'mousedown') {
            setIsOpen(false);
        }
    };
    const onButtonClick = () => {
        setIsOpen(!isOpen);
    };
    const onButtonClearClick = () => {
        onClearSelect();
    };
    const itemHeight = 55;
    const listHeight = useMemo(() => (searchData.length < 6 ? searchData.length * itemHeight : itemHeight * 6 - 20), [searchData]);
    const getTitle = () => {
        const { title } = languageData;
        if (selectedData) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "filter_button--category filter_button--textonly" },
                    title,
                    ": "),
                React.createElement("span", { className: "filter_button--items" }, selectedData.name)));
        }
        return React.createElement("span", { className: "filter_button--category" }, title);
    };
    const noResults = React.createElement("div", { className: "filter-no-results" }, languageData.noMatchesFound);
    const loadingData = React.createElement("div", { className: "filter-no-results" }, languageData.loading);
    const getContent = () => {
        if (isLoading) {
            return loadingData;
        }
        else if (searchData.length > 0) {
            return (React.createElement(List, { height: listHeight, width: 250, itemSize: itemHeight, itemCount: searchData.length }, PersonFilterResult));
        }
        return noResults;
    };
    if (selectedData) {
        return (React.createElement("div", { className: "filter-person-clear" },
            getTitle(),
            React.createElement(Button, { style: "subtle", rightIcon: crossIcon, onClick: onButtonClearClick, "aria-label": 'Inquirer filter' })));
    }
    return (React.createElement(Popover, { isOpen: isOpen, interactionKind: PopoverInteractionKind.CLICK, onInteraction: onPopoverClick, position: "bottom-left", transitionDuration: 0, autoFocus: true },
        React.createElement(Button, { className: "filter-category-button", style: "subtle", rightIcon: chevronIcon, onClick: onButtonClick, "aria-label": 'Inquirer filter' }, getTitle()),
        React.createElement("div", { className: "filter-popover-content" },
            React.createElement("div", { className: "filter-search" },
                React.createElement(TextInput, { icon: searchIcon, value: searchValue, onChange: onSearchUpdate, placeholder: '', autoFocus: true })),
            getContent())));
};
//# sourceMappingURL=PersonFilter.js.map